"use client";

import React from "react"
import {Locale} from "@/i18n-config";
import type {Content as ContentProps} from "@docid/types/src/payload-types";
import {RichText} from "@/components/content/common/RichText";
import clsx from "clsx";

type Props = {
    lang?: Locale;
    dictionary?: any;
    className?: string;
    block: ContentProps;
    position?: number;
};

export function Content({ lang, dictionary, className, block, position } : Props) {
    if (block.content) {
        return (
            <article className={clsx("page", className)}>
                <RichText data={block.content}/>
            </article>
        )
    }
}
